<template>
	<div id="market">
		<div class="maket_banner" v-cloak></div>
		<div style="border-bottom:1px solid #e5eff5;">
			<div class="xin">
				<div class="marketCTop">
					<img style="width: 18px;margin-right: 12PX;" src="http://img.anxuan360.com/Ft5w-bycguT3Abq6jNQWeP3PMrjp" alt="" />
					<p class="title">当前位置：
						<router-link to="/market"><span class="clickStyle">客户案例</span></router-link>&nbsp;>&nbsp;{{indextext[index].name}}</p>
				</div>
			</div>
		</div>

		<div class="xin">
			<div class="text">
				<h1>{{indextext[index].title}}</h1>
				<p v-html="indextext[index].text"></p>
				<div class="imgText" v-for="(item,index) in indextext[index].imgText">
					<img v-for="(items,index) in item.img" :src="items" alt="" />
					<p v-for="(items,index) in item.text">{{items}}</p>
				</div>
			</div>
			<div style="width: 677px;margin: 20px auto;" v-if="index==1">
				<p style="color: rgb(234, 34, 0);text-align: center;margin-bottom: 5px;">最后，大家再跟随我们，感受下“智慧菜场”的魅力！</p>
				<iframe frameborder="0" width="677" height="381" src="https://v.qq.com/txp/iframe/player.html?vid=s0507jircef" allowFullScreen="true"></iframe>
			</div>
			<div class="wzBottom">
				<p>{{url}}</p>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		metaInfo() {
			return {
				meta: [{
						name: 'renderer',
						content: 'http://www.ax168.com/marketC?activeIndex=' + this.index
					},
					{
						name: 'system',
						content: this.indextext[this.index].name
					},
					{
						name: 'keywords',
						content: '智慧农贸,智慧市场，智慧菜场，电子追溯，电子支付，智慧农贸,数字农贸,智慧农贸市场,智慧城市,菜篮子,农贸市场管理,农贸市场管理系统,溯源单子秤,智慧菜场,智慧菜市场,智慧市场,农贸市场智慧化建设方案,智慧微菜场,农贸市场管理软件,智慧农贸电子秤,农贸市场管理软件,菜市场管理系统,菜市场管理软件,新型农贸市场,O2O菜场，重要产品追溯系统,智慧农贸信息化平台,食品追溯监管系统,企业产品追溯系统,农产品追溯系统,仓储配送系统,智慧支付系统'
					},
					{
						name: 'description',
						content: '浙江安宣信息技术有限公司，国家高新技术企业，咨询热线0571-87357305，智慧菜场、智慧农贸、智慧农批、智慧市场、食品安全信息化监管和食品安全追溯平台以及农贸O2O电商平台。'
					}
				]
			}
		},
		data() {
			return {
				url: window.location.href,
				index: 0,
				indextext: [{
						name: '府苑新村农贸市场',
						title: '府苑新村农贸市场开业：诗意杭州热闹市井 ',
						text: '府苑新村农贸市场开业啦！！！杭州府苑新村农贸市场位于杭州紫荆花路3号府苑新村综合市场1楼，临近地铁二号线，比邻西溪湿地，地理位置得天独厚。项目周边住宅小区林立，人口密集，且附近无菜市场，市场前景看好。市场总面积为1600平方，整个农贸市场室内设计时尚。市场以暖黄色为主色调，营造和谐温馨的购物环境；灰色防滑砖地面，与空间色彩相搭配，视觉效果主次分明、亮点突出。',
						imgText: [{
								img: ['http://img.anxuan360.com/FnbgtSqATqnDvFF1fclHB1yJUTci', 'http://img.anxuan360.com/Fqv0hThK6GwjWWj-4y6Lkqf4EIvx', 'http://img.anxuan360.com/Fvg7JgUv36ziHAEQ-Mrk05fwEGcs'],
								text: ['市场入口入目就是极具东方特色的雨伞设计，室内的装饰伞可以作为一种柔化灯光、装饰点缀、营造氛围的物件存在，让市场带有东方古典美感。市场入口的一侧配有查询机器，进市场前了解每日新鲜菜价特色食材上新。']
							},
							{
								img: ['http://img.anxuan360.com/FjCawmhuWTpp6sf-tJ1latjP11yu', 'http://img.anxuan360.com/FvKf2x7cU1uHg82c3dCn0gRnsNVH'],
								text: ['摊位设计上采用传统的人字形生态木吊顶，三角结构不仅合理节省原料，有效拓展视觉空间，搭配着透光膜天花板还能营造出梦幻的室内灯光效果。酒水区成排的大红灯笼，加上堆积的酒坛，仿佛来到了明清时代的小客栈。卤味区分隔的包间设计干净整洁，只为保障老百姓的食品安全。']
							},
							{
								img: ['http://img.anxuan360.com/FjHrx58IRL6OFsvehntLv7_-VmTu', 'http://img.anxuan360.com/FmTQmcllAXeJsj_1iMSjQFv7dcFn'],
								text: ['水产区，台面有一定倾斜度，并且在最低一侧设有排水槽，槽内的水经过地漏和PVC排水管排入摊位内部地面的明沟内，明沟内积水汇聚在摊位内集水井中，直接排入通道上现有集水井，将摊位内外的排水系统一分为二，不再相互干扰。']
							},
							{
								img: ['http://img.anxuan360.com/FriGD5-ITYNxCkOi9bKPEe5aSWaM'],
								text: ['在市场的蔬菜摊位，通过自然采光补充照明效果，蔬果更显娇翠，与接地气的摊位设计构成了一幅明丽的田园画作。食材码放整齐，看着分门别类摆放缤纷各异的蔬果，是一种美好的视觉享受。府苑新村农贸市场每个摊位都配备着智能显示屏，上面显示摊主的信息食材价格检测结果等，力求让顾客买得放心，吃得安心。']
							},
							{
								img: ['http://img.anxuan360.com/FiYKeoPLJZ20ay5sbBk34bKl4unJ'],
								text: ['鲜肉摊位采用包厢式设计，让视觉效果更为通透，更具整体性。灯光设计上除了常规的LED灯外，还采用了肉类专用生鲜射灯，与鲜肉区的整体风格相得益彰。']
							},
							{
								img: ['http://img.anxuan360.com/FtVoUxX52ozIwsvLqcNoCV6owSvu'],
								text: ['人间烟火，最抚人心。不管算法再高级，也无法读懂菜市场的嘈杂和生动。技术再智能，也再现不了街巷的斑斓色彩。智慧零售让生活更简单多元，但某些场景下，仪式感才是最被需要的东西。上街买菜、回家做饭，无论时代如何变迁，生活总保有它的温暖底色。菜市场的功能从未被弱化。这里有城市生活的必需品和调味剂，它是一种生活方式，是共同的记忆，是城市的符号。多元化社会、多样化需求，催生出“百面”菜市场。“大而全”也好，“小而精”也罢，菜市场的进阶和蝶变，是城市更新绕不过去的一环。除了环境越来越好，质量越来越放心，一个显而易见的变化是：单纯买菜的功能在弱化，期待着更多的嵌入式创新。']
							},
							{
								img: ['http://img.anxuan360.com/FkpqrCEduoncIWFrbL1yDsFm7LaZ'],
								text: ['菜市场可以是午夜食堂，可以是邻里中心，是社交空间，也可以是文化转角，甚至可以是旅游目的地、网红打卡地。菜市场怎么升级，杭州给出了标准，但未划定“模式”和“样板”。这让老百姓对菜市场有了更多期待，更多惊喜。光影农贸市场设计研究院专注农贸市场设计18年，在全国32省市的农贸市场进行了大量调研，高水准设计出符合地区的星级农贸市场。科学设计摊位大小，合理分布蔬菜水果鲜肉家禽水产干货粮油业态，赢得了政府，消费者，经营户一致好评。']
							}
						]
					},

					{
						name: '东阳西门市场',
						title: '福利！凭二维码就能搞定一切……这样的“智慧菜场”在东阳亮相了',
						text: '这样的“智慧菜场”来了，你想去逛一逛吗？',
						imgText: [{
								img: ['http://img.anxuan360.com/FjYZwhLkMQ5EtF6B1SgltD1ol3uC'],
								text: ['这两天到东门菜场、西门菜场买菜的小伙伴可能会纳闷，菜场的电子秤怎么跟以往不一样？电子秤“吐出”的购物小票是干嘛用的？微信、支付宝支付二维码怎么不见了？别急，小编为你一一解答。']
							},
							{
								img: ['http://img.anxuan360.com/FrhmjCNB2DHWyFQjnS6FWbKEUh-J'],
								text: ['以后到“智慧菜场”买菜再也不会被支付方式困扰了，一个二维码就可以解决。我局联合东阳农商银行推出了“丰收一码通”。消费者可以选择微信、支付宝以及丰收互联APP任意一种方式付款。“花式”付款，就是这么任性！']
							},
							{
								img: ['http://img.anxuan360.com/FiYlGbGcg5IeqzP8IekvJ-fIs1QP'],
								text: ['“今天的西红柿多少钱一斤？”“这菜有这么重？是不是缺斤短两……”，买菜的时候懒得问，买回家又犯嘀咕。这样的烦恼，以后购物小票都会帮你解决。']
							},
							{
								img: ['http://img.anxuan360.com/Ft_iXCvhJE7eCHBLoA85kkeV5j5t'],
								text: ['别以为这就完了！看到熟食店摆放的电子显示屏没有？这是多功能一体机。厉害了！它集支付二维码、价格显示、经营户信息、公告视频、监控视频于一体。在这里，跟你透露个内部消息，下一步，我局将在熟食加工场所安装监控探头，将加工场所视频信息在销售点的多功能一体机进行播放，将经营者整个加工过程展现在消费者面前。']
							}
						]
					},
					{
						name: '义乌词林菜场',
						title: '全省农批市场食品安全规范化建设现场推进会在义乌召开',
						text: '9月19日，全省农批市场食品安全规范化建设现场推进会在义乌召开。省食品安全委员会办公室专职副主任、省食品药品监督管理局副局长卢永福出席会议并讲话，省财政厅、省食品药品监督管理局相关处室负责人及全省各地市市场监督管理局相关负责人、食用农产品批发市场（简称“农批市场”）负责人共110人参加会议。',
						imgText: [{
								img: ['http://img.anxuan360.com/FlOMyvrIvYevPw6Yc2hcQ5zQbPRm'],
								text: ['我省自2017年提出并部署推进食用农产品批发市场食品安全规范化建设以来，全省各地对标整改，加大投入，狠抓落实，开拓创新，全省农批市场的日常管理不断规范，市场举办方、入场销售者的主体责任意识大大增强，电子追溯体系建设等难点问题不断突破，农批市场保障食品安全的能力得到持续提升，创建工作开局良好，取得了重要阶段性成效。']
							},
							{
								img: ['http://img.anxuan360.com/FgTpc1UCXCKQxYaRqUsJ5rYgj_im', 'http://img.anxuan360.com/Frl18B0Rde-8ZQMOcr8PSUBD4pfa'],
								text: ['    正是这些特点，体现了我省抓农批市场食品安全规范化建设的重要性。开展农批市场食品安全规范化建设，是贯彻落实法律法规的有力抓手，是保障区域食品安全的‘牛鼻子’工程，是提升农批市场日常管理水平的现实需要。']
							},
							{
								img: ['http://img.anxuan360.com/FhZG2D5mVc3nJr-SelVZ1fJ3zr-z'],
								text: ['下一步，抓好七方面工作：市场准入、日常管理、检验检测、不合格产品处置、电子追溯、统一标识标牌、源头摸底。做到明确责任，加紧落实；突出重点，加大投入；浓厚氛围，加强指导；严格标准，按期验收。', '会上，义乌市政府和金华市局领导作了致辞，杭州市局、嘉兴市局，义乌市局、宁波市水产品批发市场有限公司、台州（中国•农港城）、温州菜篮子农副产品批发交易市场等六个单位作了典型发言。']
							},
							{
								img: ['http://img.anxuan360.com/FijvShVt3Vl6AAcAgfuKGRzdyUiF'],
								text: ['与会人员现场考察了义乌市浙中农副产品物流中心和义乌词林菜市场']
							}
						]
					},
					{
						name: '磐安安文蔬菜市场',
						title: '扫码可溯源 山城磐安打造智慧蔬菜市场 ',
						text: '“扫这里，扫这里，扫这里有奖励的！”菜市场副食区的陈大伯憨厚地笑道，“农商行扫码真方便，直接到帐，提现都不用手续费咧，而且做的好有100元现金奖励！”“那可真不错呐！”消费者大妈羡慕的附和着。',
						imgText: [{
							img: ['http://img.anxuan360.com/Fgb_otN1b-UQ1huAx0VoRjxiKw4l'],
							text: ['磐安县城区蔬菜市场于今年迁移到位于县城昌文路6号的新址目前共有140个商户入驻市场，市场分为鲜肉、熟食、野味、蔬菜、副食等17个区域，该菜市场是目前磐安县内菜品销售种类最多、人流量最大的菜市场。为了让新市场达到规范经营、放心购买、安全食用的目标，该县市场监管局与农商银行合作，推出两大实招：一是推进食品溯源系统建设。实现市场内经营户的电子秤与农商银行一码通产品相互连接，消费者通过扫码支付就能了解到食品的安全情况，实现蔬菜从田间到商户交易全程可追溯。二是开展商户电子交易激励活动。县农商银行对该蔬菜市场使用一码通产品支付渠道的商户进行奖励，奖励方式为对交易金额和交易笔数排名前15商户进行现金奖励。自激励措施推出后，智慧菜场的平均业务量比6月翻了3翻，即使用电子渠道支付的商户已超过70%，7月份商户交易笔数高达50833笔，商户交易金额为1652761.75元。这两项举措的推出，让山城的智慧蔬菜市场初见成效。']
						}]
					},
					{
						name: '温岭水果批发市场',
						title: '温岭市果蔬批发市场迎“五一”特惠大酬宾活动',
						text: '',
						imgText: [{
							img: ['http://img.anxuan360.com/FgCVeNTH2hqXOclrR49xFFIY80XB', 'http://img.anxuan360.com/Ft_Slr-vlgq7-EtkpLIuGQXYaL-Q'],
							text: ['最美人间四月天，正是水果集中上市时', '温岭市果蔬批发市场，迎“五一”特惠大酬宾！！！', '刷丰收信用卡，或是丰收互联、微信、支付宝扫码，都有优惠！', '消费满百还能抽大奖！', '品牌电瓶车、水果券1000元、', '压力锅、雨伞、纸巾...', '中奖率高达近50% ！！！']
						}, {
							img: ['http://img.anxuan360.com/Fvd7Brww56xCfH5VMUCsxn6L7cXF', 'http://img.anxuan360.com/Fp7tss3ldtZsviYs12vnbqIdmQyb', 'http://img.anxuan360.com/Fm9z6MdITLDgvnWoYxjbFfMRqHRQ', 'http://img.anxuan360.com/FkpvJ-fmQ_IVU4JB-HOsxwoxOH75', 'http://img.anxuan360.com/Ft5CPvYDinDCq75d03znAKQ6RpJd'],
							text: ['说起温岭市果蔬批发市场，很多人一时没反应过来，它有另外一个你熟悉的名字：水果行']
						}, {
							img: ['http://img.anxuan360.com/Fpzf3wlnD1oOUrEyjqMBkeG_-oji'],
							text: ['在五一到来之际，温岭市果蔬批发市场和温岭农商银行，给您带来实打实的优惠！']
						}, {
							img: ['http://img.anxuan360.com/FvMHy894MQfWnaojA9oI5UPNJqWT'],
							text: ['“刷丰收信用卡满减， 扫丰收智能付立减， 消费满百抽大奖”', '――温岭市果蔬批发市场迎“五一”特惠大酬宾活动', '活动时间', ' 2018年4月28至5月1日（每天8：00-17：00）', '活动对象', '通过温岭农商银行丰收智能付POS机消费的所有客户', '活动地点', '温岭市果蔬批发市场（也就是水果行）（地址：温岭市万泉西路399号）', '活动内容', '1、持温岭农商银行丰收信用卡在丰收智能付POS机上刷卡消费，享受单笔满减优惠，单笔满100元立减10元、满300元立减30元、满500元立减50元，单卡单日只限享受一次，按最高档计算，先到先得，送完即止。', '2、使用温岭农商银行丰收互联（手机银行）在丰收智能付POS机上扫码消费，享受随机立减优惠，最高减免88.88元，单户单日只限享受一次，先到先得，送完即止。', '3、使用微信、支付宝在丰收智能付POS机上扫码消费，也能享受随机立减优惠，最高减免18.88元，单户单日只限享受一次，先到先得，送完即止。', '4、在市场水果区通过丰收智能付POS机消费满100元的所有消费者，都可参加抽大奖活动。', '奖项设置', '一等奖：品牌电瓶车一辆（共4名，每天设一名，当日无人中奖的滚入下一天奖池。', '二等奖：市场水果抵用券1000元（任何摊位可用，共8名，每天设两名，当日无人中奖的滚入下一天奖池。）', '三等奖：品牌压力锅一台（共20名，每天设5名，当日无人中奖的滚入下一天奖池。）', '四等奖：雨伞一把（共500名，奖完为止。）', '鼓励奖：纸巾一包（共2000名，奖完为止。）', '抽奖中奖率高达近50%', '活动说明', '1、本活动仅限于温岭市果蔬批发市场内的温岭农商银行丰收智能付特约商户。', '2、参与刷丰收信用卡满减、使用丰收互联扫丰收智能付随机立减、使用微信和支付宝扫丰收智能付随便机立减这三项活动的，单日分别只限享受一次。', '3、参与通过丰收智能付消费满100元抽大奖活动的可叠加，每户限50次。', '4、活动中如出现任何违规、欺诈、不正常交易或其他恶意违反活动相关规定的情况，温岭市果蔬批发市场和温岭农商银行将有权拒绝该客户参与本次活动并取消其获赠的任何奖励。', '5、本次活动最终解释权归温岭市果蔬批发市场和温岭农商银行所有。']
						}, ]
					},
					{
						name: '庆元香菇市场',
						title: '丽水市探索“互联网+食品”溯源体系 管理模式成效显著',
						text: '丽水食品溯源体系建设刷卡消费破亿</br>2015年以来，丽水市市场监管局以“源头可溯、全程可控、风险可防、责任可究、公众可查”为目标，探索“政府－银行－市场”三方合作模式。 目前丽水市溯源系统运行稳定、上下游数据对接有效、经营户和消费者逐步接受、社会各界反响良好，溯源体系建设取得初步成效。截止2017年1月17日，全市9个县(市、区)22个城区农贸市场的1626家经营户安装了电子溯源设备，实现交易笔数1465782笔，溯源金额1.19亿元，其中刷卡溯源244367笔，刷卡金额5398.27万元。 ',
						imgText: [{
								img: ['http://img.anxuan360.com/FgLPnH-LnxSHlJ9o5dqRzTLU262M'],
								text: [' 2015年8月5日朱从玖副省长到丽水仓前菜市场调研食品安全溯源体系建设。', '丽水食品溯源体系建设获书记点赞', '该局通过借助农信系统平台，在全国首创食品安全全程溯源体系建设，完善从田头到餐桌的食品安全全程管控体系，有效整治餐桌安全问题，实现“源头可追溯、过程可监控、消费可召回”食品流通新格局。', '2016年，6月23日上午，市委书记史济锡、市长朱晨等市领导到仓前农贸市场调研食品安全溯源体系建设情况。']
							},
							{
								img: ['http://img.anxuan360.com/FrgBFnUERRJhWMjvTxRKI7Ob_5zF'],
								text: ['2016年，6月23日上午，市委书记史济锡、市长朱晨等市领导到仓前农贸市场调研食品安全溯源体系建设情况。']
							},
							{
								img: ['http://img.anxuan360.com/FsdWY1Wr-giRVCTRpDwkmX6SX-af'],
								text: ['在蔬菜摊位前，市委史济锡书记现场体验了刷卡买菜，并通过手机扫描购物小票上的二维码快速查看到商品进货渠道、检测结果、销售经营户等信息后，他认为市市场监管局推行的食品安全溯源体系建设工作这项工作很好，值得竖大拇指点赞。']
							},
							{
								img: [],
								text: ['准确定位，加强政策指导', '丽水市委市政府努力推进食品安全治理能力提升，多管齐下强化食品安全监管，积极打造与“秀山丽水、养生福地、长寿之乡”相匹配的食品安全水平。明确战略目标。确立“完善全过程监管机制，建立食品原产地可追溯制度”的战略目标，把食品安全溯源体系建设列入丽水十三五发展规划和市委全面深化改革领导小组工作要点和创新工作。同时，将食品安全溯源体系建设作为提升市民幸福指数的重要工作，列入2016年丽水十大民生实事工程。出台实施意见。印发《关于开展食品安全溯源体系建设的实施意见》(丽政办发〔2016〕12号)，明确用三年左右的时间建成溯源体系，做到食品来源可追溯、去向可查证、风险可管控、责任可追究。']
							},
							{
								img: ['http://img.anxuan360.com/FnajwRG_Eq2N9NhbpdK_RkN8kBE7'],
								text: ['手机扫一扫就能知道食品的相关信息', '创新发展，探索溯源模式', ' 丽水围绕核心“社会共治”，立足自身优势，探索“政府—银行—市场”三方合作模式，形成了一套全新的溯源模式。', '加强政银合作', '  溯源体系建设既不能由政府单打独斗，也不能完全由社会力量市场化运作，而要通过社会共治、多方合作来有效推进。按照这一思路，该市通过竞争性谈判，并采取PPP模式由农商银行投入1.6亿资金推进项目建设。', '强化信息共享', '通过开发溯源电子秤与POS机信息交互功能，建立统一的追溯平台，以食品安全安心卡(银联卡)为介质，将种植养殖环节、屠宰环节、批零(配送)环节、直至餐桌消费的各个环节的来源和检测等数据联通与集成，完善追溯链条。目前，已经打通批发到零售环节，种植养殖环节正在开发系统与接入。']
							},
							{
								img: ['http://img.anxuan360.com/FroAfEy0NpvLu3V-vie9LosTNabY'],
								text: ['市场统一使用的溯源机器']
							},
							{
								img: ['http://img.anxuan360.com/FvtHx69Vd-CtFUPsOlnKzCG9OQv6'],
								text: ['食品来源信息，都在消费清单中查询']
							},
							{
								img: [],
								text: ['深化技术创新', '溯源体系建设涉及硬件集成、软件整合等工作，尤其是银行的安全性问题。经过近一年的开发运行，逐一解决了VPN通道、3G-4G网络通道、POS签到、资金到账、银联T+0等问题。国内首台安卓版溯源电子秤于2015后7月份正式投产，填补了国内空白，目前设备的专利正在申请。首个溯源体系建设标准也即将出台。']
							},
							{
								img: ['http://img.anxuan360.com/FmmS6bQqCeb7nR1MV-ygP0sud7wq'],
								text: ['每个摊位都有溯源PS机']
							},
							{
								img: ['http://img.anxuan360.com/FqKX45gI3b_33ml46mArwd8KLsaR'],
								text: ['扫一扫即可了解家禽的进货时间和商铺信息，遇到质量问题，保留清单，即可投诉。']
							},
							{
								img: [],
								text: ['统一标准，积极扎实推进', '丽水溯源按照全市“统一模板、环节互通、同步推进”的格局一盘棋运行，确保全市三年内全面完成溯源体系建设。平台统一开发。市本级投入300多万设计统一的追溯平台，包括交易运行环境、应用系统、结算系统等，追溯流程采集的数据最终都汇集到数据库中，数据库通过交易数据中的关键追溯标识运用，统一实现追溯。该平台涵盖各县（市、区）食品安全追溯和交易数据，各地无须另行开发。', '设备统一采购', '由农信系统统一对溯源电子秤、POS机以及支架设备和网络运营进行招投标，确定集成商，实行统一价格、统一管理、统一安装、统一维护，各县市依据招投标情况予以推进，减少各自为政，提高推进速度和效果。截至目前，已为12个市场安装3G网络基站，安装电子秤和POS机1626台，办理食品安全溯源安心卡7.2万张。']
							},
							{
								img: ['http://img.anxuan360.com/Fm9sNPDuhiJWsKRPNlFOzxKrQFUi'],
								text: ['丽水各大市场你都能见到的食品溯源PS机']
							},
							{
								img: [],
								text: ['市场统一准入', '根据国家食品药品监督管理总局《食用农产品市场销售质量安全监督管理办法》，结合本地实际出台《丽水市产地准出与市场准入制度》，明确准出与准入范围、条件，禁入范围，职责分工和数据采集等规范要求，该制度成为丽水首个正式出台的食用农产品准入规范性文件。以农贸市场为采样点进行调研收集，并参照农业部农产品品名分类，出台《丽水市场销售环节食用农产品信息分类编码》，该分类共计17个大类1480品名，明确市场准入、快速检测、追溯召回等实行品名的统一规范化。']
							},
							{
								img: ['http://img.anxuan360.com/Fp-TG_uyRsK7w7IdWoDFauYnBpMN', 'http://img.anxuan360.com/FpBnYo22i4SKxNiBjD8dSbGiHh2v', 'http://img.anxuan360.com/Fmb7MVRU5NKOOhEx32XNR_nLr9km'],
								text: ['拿出手机，扫描二维码，即可看见了解食品的进货商铺，进货时间等信息']
							},
							{
								img: [],
								text: ['快检统一运行', '按照 “县市一盘棋、设备一体机、管理一体化”和以农批市场快检实验室为龙头、中心菜市场检测室为重点、大型商场超市和小型菜市场检测点为补充的食用农产品快速检测体系，实现农批市场批批检测、农贸市场重点检测的目标，并全部与溯源体系同步。']
							},
							{
								img: ['http://img.anxuan360.com/FsgYhpT8TdRsIzH_dO1Gv9VTVvyI'],
								text: ['加强引导，提升监管效能', '引导诚信经营。组织金融机构与市场监管局、农业局、水利局、林业局等食品安全监管部门对接，制定《关于建立食安金融联合惩戒机制的通知》，建立食品安全信息共享库，在将农户信用评价信息纳入共享、查询的同时，定期采集查询由实时录入的食品安全不良信息，并通过与农户信用评价衔接、与企业信用报告衔接，延伸食品安全不良信息在银行客户信用信息中应用，为食品行业客户授信、利率定价提供依据。截至目前，全市已有49万户居民、3.5万家食品生产经营主体建立信用档案，公示“黑榜”79家，发出惩戒告知书60余份，限制贷款31家。']
							},
							{
								img: ['http://img.anxuan360.com/FuEtkRzNrbUZ6ojsKrIL_L0Iu9vH'],
								text: ['严格开展执法。完善食品安全排查机制，对日常巡查具体内容分门别类进行细划完善，通过整合全市70家监管部门的执法资源，建成173个乡镇（街道）、2855个行政村（社区）的管理框架，配备食品安全管理员4264名，利用日常巡查，现场采集食品安全主体信息和经营信息，录入至“食品安全社会协同管理平台”，使食品安全监管异常信息从采集到处置流程进一步简化、及时、快速。目前，全市已通过手机“食安通”上传巡查记录403562条，监督执法人员及时对75378户次巡查结果不合格的食品生产经营单位进行检查处理。']
							}
						]
					}
				]
			}
		},
		activated() {
			document.documentElement.style.fontSize = "";
		},
		mounted: function() {
			window.scrollTo(0, 450)
			this.index = this.$route.query.activeIndex
		},
		methods: {

		},
		components: {

		},
		watch: {
			$route(to, from) {
				if(to.name == 'marketC') {
					this.index = to.query.activeIndex
				}
			}

		},
	}
</script>

<style scoped>
	@import url("../css/market.css");
	[v-cloak] {
		display: none !important;
	}
	
	.text {
		text-align: center;
	}
	
	.text p {
		font-size: 16px;
		color: #6C7585;
		line-height: 40px;
		padding: 0 200px;
	}
	
	.wzBottom {
		margin-top: 60px;
		margin-bottom: 50px;
		height: 53px;
		line-height: 53px;
		border-top: 1px solid #E5EFF5;
		border-bottom: 1px solid #E5EFF5;
	}
	
	.wzBottom p {
		text-align: center;
		font-size: 16px;
		color: #4a4a4a;
		-moz-user-select: text;
		/* Firefox私有属性 */
		-webkit-user-select: text;
		/* WebKit内核私有属性 */
		-ms-user-select: text;
		/* IE私有属性(IE10及以后) */
		-khtml-user-select: text;
		/* KHTML内核私有属性 */
		-o-user-select: text;
		/* Opera私有属性 */
		user-select: text;
		/* CSS3属性 */
	}
	
	.imgText {
		margin-top: 15px;
	}
	
	.text img {
		display: block;
		margin: 0 auto;
		margin-bottom: 20px;
	}
	
	.text h1 {
		font-size: 18px;
		color: #444444;
		font-weight: 400;
		margin-top: 30px;
		line-height: 62px;
	}
	
	.xin {
		width: 1256px;
		margin: 0 auto;
	}
	
	#market .title {
		font-size: 14px;
		color: #444444;
	}
	
	#market .title span {
		color: #444444;
	}
	
	#market .title span:hover {
		color: #00C59F;
	}
	
	.marketCTop {
		height: 76px;
		display: flex;
		align-items: center;
	}
</style>


// WEBPACK FOOTER //
// src/components/marketC.vue